import { ReactComponent as FilterClearIcon } from "assets/icons/filter-clear.svg";
import { handleKeyDown } from "modules/common/utils/keyboardUtils";

interface Props {
    show: boolean;
    onClearFilter: () => void;
    className?: string;
}

export const FilterClear = ({ show, onClearFilter, className }: Props) => {
    return show ? (
        <div className={className} tabIndex={0} onKeyDown={e => handleKeyDown(e, onClearFilter)}>
            <FilterClearIcon onClick={onClearFilter} style={{ cursor: "pointer" }} />
        </div>
    ) : (
        <></>
    );
};
